<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <v-card>
      <vue-card-title
        :title="'Client Source'"
        :subtitle="
          'Refer to the following information client source for all the organizations.'
        "
        :icon="$getIcon('mdiClipboardTextOutline')"
      >
        <template slot="actions">
          <v-btn
            class="indigo accent-2 white--text text-capitalize my-0"
            small
            @click="clientSourceForm = true"
          >
            Create Source
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row v-if="!fetched">
          <v-col cols="12">
            <vue-default-svg-loader></vue-default-svg-loader>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <vue-pagination-component
              :fetch-api.sync="fetchAPI"
              :search-label="searchLabel"
              :query-params.sync="queryParams"
              :filter-query="queryParams"
              :next-link="nextLink"
              :previous-link="previousLink"
              :pagination-info="paginationInfo"
            ></vue-pagination-component>
          </v-col>
          <v-col v-if="fetchedData.length < 1 && filtered" cols="12">
            Search results not found.
          </v-col>
          <v-col v-else-if="fetchedData.length < 1" cols="12">
            <vue-no-data></vue-no-data>
          </v-col>
          <v-col
            v-for="(source, index) in fetchedData"
            v-else
            :key="index"
            class="text-center"
            md="3"
            cols="6"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 5 : 2}`"
                class="pointer border"
              >
                <v-card-text class="blue-grey lighten-5">
                  <v-icon size="50">
                    {{ $options.mediumIcons[source.icon] }}
                  </v-icon>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <h4 class="blue--text font-weight-bold">
                    {{ source.name }}
                  </h4>

                  <small class="d-block">{{ source.description }}</small>
                  <a
                    class="font-0 grey--text cursor-pointer"
                    @click="
                      (selectedClientSource = source) &&
                        (clientSourceForm = true)
                    "
                  >
                    Update
                  </a>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div>
      <v-bottom-sheet v-model="clientSourceForm" scrollable>
        <v-card tile>
          <vue-card-title
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on communication medium.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="clientSourceForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <client-source-form
              v-if="selectedClientSource && clientSourceForm"
              :action-data="selectedClientSource"
              :mediumIcons="$options.mediumIcons"
              @clientSourceResponse="formSuccess"
            >
            </client-source-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
    </div>
  </vue-page-wrapper>
</template>
<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import ClientSourceForm from "@/components/crm/configuration/client_source/forms/ClientSourceForm";
import mediumIcons from "@/utils/mediumIcons.js";

export default {
  mediumIcons,
  components: {
    ClientSourceForm
  },
  mixins: [PaginationMixin],
  data() {
    return {
      htmlTitle: "Client Source",
      breadCrumbItems: [{ text: "Client Source", disabled: true }],
      // paginationMixin
      fetchAPI: "/api/v1/crm/client-source/",
      searchLabel: "Search for client source",
      // form
      clientSourceForm: false,
      selectedClientSource: {},
      cardTitle: ""
    };
  },
  watch: {
    clientSourceForm(newVal) {
      if (Object.keys(this.selectedClientSource).length > 0 && newVal) {
        this.cardTitle = "Update Client Source";
      } else {
        this.selectedClientSource = {};
        this.cardTitle = "Create Client Source";
      }
    }
  },
  methods: {
    formSuccess() {
      this.clientSourceForm = false;
      this.fetchData();
    }
  }
};
</script>
